// extracted by mini-css-extract-plugin
export default {"gridContainer":"stacks_gridContainer__aL1td","visualizer":"stacks_visualizer__E1ybg"};